import {
  Breadcrumb,
  Button,
  Form,
  Input,
  Popconfirm,
  Divider,
  Switch,
  Typography,
  message,
} from "antd";
import { Content } from "antd/es/layout/layout";
import { useLoaderData } from "react-router-dom";
import { useRouteActivity } from "~/hooks/useRouteActivity";
import { useTranslation } from "react-i18next";
import { useCreateOrganizationPage } from "./hooks";
import { breadcrumbHomeItem, breadcrumbItem } from "~/components";
import { INTENTS } from "~/utils";
import { CreateOrganizationLoaderType } from "./loader/CreateOrganizationLoader";

const CreateOrganizationPage = () => {
  const loaderData = useLoaderData() as CreateOrganizationLoaderType;
  const { t } = useTranslation();
  const [formInstance] = Form.useForm();
  const formState = useCreateOrganizationPage({ formInstance });
  const { isFormBusy } = useRouteActivity();
  const disabled = isFormBusy || formState.isLoading;

  return (
    <>
      <Breadcrumb
        separator=">"
        items={[breadcrumbHomeItem, breadcrumbItem(t("New_Organization"))]}
      />
      <Content>
        <>
          <Typography.Title level={1}>{t("Add_Organization")}</Typography.Title>
          <div style={{ maxWidth: 400, width: "100%" }}>
            <Form
              form={formInstance}
              onFinish={formState.handleSubmit}
              disabled={disabled}
            >
              <Form.Item label={t("Name")} name={"name"}>
                <Input disabled={disabled} />
              </Form.Item>
              <Form.Item
                label={t("Transfer_Properties")}
                name={"transferProperties"}
                initialValue={false}
              >
                <Switch disabled={disabled} />
              </Form.Item>
              <Form.Item>
                <Popconfirm
                  title={t("Confirm_changes")}
                  onConfirm={() => {
                    if (formInstance.getFieldValue("name") === "") {
                      message.error(t("Please_enter_a_name"));
                      return;
                    }
                    formState.handlePopUpSubmit(INTENTS._create_organization);
                  }}
                >
                  <Button
                    type="primary"
                    onClick={formState.togglePopUpConfirm}
                    disabled={disabled}
                    loading={formState.isLoading}
                  >
                    {t("Submit")}
                  </Button>
                </Popconfirm>
              </Form.Item>

              <Divider />

              <Typography.Title level={1}>
                {t("Request_to_join_organization")}
              </Typography.Title>
              <Form.Item
                label={t("Code")}
                name={"code"}
                initialValue={loaderData.code}
              >
                <Input disabled={disabled} />
              </Form.Item>
              <Form.Item
                label={t("Transfer_Properties")}
                name={"requestTransferProperties"}
                initialValue={false}
              >
                <Switch disabled={disabled} />
              </Form.Item>
              <Form.Item>
                <Popconfirm
                  title={t("Confirm_changes")}
                  onConfirm={() => {
                    if (formInstance.getFieldValue("code") === "") {
                      message.error(t("Please_enter_a_code"));
                      return;
                    }
                    formState.handlePopUpSubmit(INTENTS._request_organization);
                  }}
                >
                  <Button
                    type="primary"
                    onClick={formState.togglePopUpConfirm}
                    disabled={disabled}
                    loading={formState.isLoading}
                  >
                    {t("Submit")}
                  </Button>
                </Popconfirm>
              </Form.Item>
            </Form>
          </div>
        </>
      </Content>
    </>
  );
};

export default CreateOrganizationPage;
